import { Box, Stack, Typography } from "@mui/material";
import { ReactElement } from "react";

import uploadedImage from "../../../../../assets/image/snail-verified.png";
import { Button } from "../../../../../shared/ui";

type TExportFileUploadedProps = {
  contactsCount: null | number;
  onReset: () => void;
  onUpload: () => void;
};

const ExportFileUploaded = ({
  contactsCount,
  onReset,
  onUpload,
}: TExportFileUploadedProps): ReactElement => {
  return (
    <Stack sx={styles.wrapper}>
      <Box alt="snail" component="img" src={uploadedImage} width={73} />
      <Typography sx={{ fontSize: "24px", fontWeight: 700, marginTop: "16px" }}>
        Well done!
      </Typography>
      <Typography sx={styles.contacts}>
        <span>{contactsCount}</span>profiles found
      </Typography>
      <Stack alignItems="center" direction="row" gap="16px" mt="24px">
        <Button
          className="exportFileUploaded-button"
          onClick={onReset}
          variant="bordered-dark"
        >
          Try with another file
        </Button>
        <Button
          className="exportFileUploaded-button"
          onClick={onUpload}
          variant="primary"
        >
          Upload
        </Button>
      </Stack>
    </Stack>
  );
};

const styles = {
  button: {
    lineHeight: 1,
    marginTop: "16px",
    textTransform: "none",
  },
  contacts: {
    "& > span": {
      color: "var(--black)",
      fontSize: "18px",
    },
    alignItems: "center",
    color: "var(--text-grey)",
    display: "inline-flex",
    fontSize: "12px",
    fontWeight: 600,
    gap: "4px",
    lineHeight: 1.5,
    marginTop: "8px",
  },
  wrapper: {
    "& .exportFileUploaded-button": {
      height: "32px",
      width: "200px",
    },
    alignItems: "center",
    padding: "34px 24px 28px",
  },
};

export default ExportFileUploaded;
